import consts from "../consts";

import { Container, AnimatedSprite, Sprite } from 'pixi.js';

export default class Symbol extends Container {

    constructor(resources, { num, inReelIndex, fakeSymbol }) {
        super();
        this.num = num;
        this.index = inReelIndex;
        this.spriteName = '';
        this.animationName = '';
        this.data = {};
        this.resources = resources;
        this.isFakeSymbol = fakeSymbol

        this._sprite = null;

        this.init();
    }

    init() {
        this.getSymbolData();
        this.loadSprite();
        this.setSize();
    }

    loadSprite() {
        if (!this.isFakeSymbol) {
            if (!this.spriteName || !this.animationName) throw new Error('Unknown sprite');
            this._sprite = new AnimatedSprite(this.resources[this.spriteName].spritesheet.animations[this.animationName]);
            this._sprite.name = this.spriteName;
            this._sprite.num = this.num
            this._sprite.index = this.index
            this._sprite.loop = false;
            this._sprite.animationSpeed = 0.5;
        } else {
            this._sprite = new Sprite(this.resources[this.spriteName].textures[this.spriteName + "_00.png"]);
            this._sprite.name = this.spriteName;
            this._sprite.num = this.num
            this._sprite.index = this.index
        }
        
    }

    setAnimationSpeed(speed = 1) {
        this._sprite.animationSpeed = speed;
    }

    get sprite() {
        return this._sprite;
    }

    getSymbolData(){
        if (!this.isFakeSymbol) {
            this.data = consts.assets.symbol.animatedSprites.find(symbol => symbol.num === this.num);
            this.animationName = this.data.animationName;
            this.spriteName = this.data.name;   
        } else {
            this.data = consts.assets.symbol.animatedSprites.find(symbol => symbol.num === this.num);
            this.spriteName = this.data.name;  
        }
    }

    setSize() {
        this._sprite.x = 0;
        this._sprite.y = this.index * 252;

        switch (this.spriteName) {
            case 'nine':
                 this._sprite.x += 80;
                 this._sprite.y += 59;
            break;
            case 'ten':
                 this._sprite.x += 55;
                 this._sprite.y += 48;
            break;
            case 'jack':
                 this._sprite.x += 60;
                 this._sprite.y += 52;
            break;
            case 'queen':
                 this._sprite.x += 60;
                 this._sprite.y += 52;
            break;
            case 'king':
                 this._sprite.x += 60;
                 this._sprite.y += 52;
            break;
            case 'ace':
                 this._sprite.x += 60;
                 this._sprite.y += 52;
            break;
            case 'orchid':
                 this._sprite.x += 30;
                 this._sprite.y += 42;
            break;
            case 'vase':
                 this._sprite.x += 30;
                 this._sprite.y += 35;
            break;
            case 'knife':
                 this._sprite.x += 30;
                 this._sprite.y += 20;
            break;
            case 'horse':
                 this._sprite.x += 25;
                 this._sprite.y += 25;
            break;
            case 'chengiz':
                 this._sprite.x += 25;
                 this._sprite.y += 25;
            break;
            case 'wild':
                 this._sprite.x += 25;
                 this._sprite.y += 25;
            break;
            case 'scatter':
                 this._sprite.x += 25;
                 this._sprite.y += 32;
            break;
            case 'expandedWild':
                 this._sprite.x += 25;
                 this._sprite.y += 25;
            break;
        }
    }

}